export default "__VITE_ASSET__DIzfZlT4__"